import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import { History } from 'history'
import { MessageKind } from 'uiComponents/messages'
import { FullWidthContainerBody } from 'uiComponents/settingsContainer'
import WithRoutePermission from 'routes/guards/withRoutePermission'
import InventoryListPage from 'inventory/list'
import CrowdControlForm from 'inventory/crowdControl'
import InventoryRuleForm from 'inventory/ruleEditForm'
import { CAPACITY_ROUTES } from './paths'

export interface CapacityRoutesProps {
    history: History
    accountSlug: string
    setActiveSection: (section: string, header: string) => void
    replaceMessages: (id: string, status: MessageKind, text: string) => void
    removeAllMessages: () => void
    source: '?from=flat' | '?from=nested'
}

export function CapacityRoutes(props: CapacityRoutesProps) {
    const { history, accountSlug, setActiveSection, replaceMessages, removeAllMessages, source } = props
    return (
        <Switch>
            <Route
                path={CAPACITY_ROUTES.list}
                render={() => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <InventoryListPage
                                history={history}
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                source={source}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
            <Route
                path={CAPACITY_ROUTES.item}
                render={() => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <CrowdControlForm
                                history={history}
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                removeAllMessages={removeAllMessages}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
            <Route
                path={CAPACITY_ROUTES.exception}
                render={() => (
                    <WithRoutePermission requiredPermissions={['partner_admin']}>
                        <FullWidthContainerBody>
                            <InventoryRuleForm
                                history={history}
                                accountSlug={accountSlug}
                                setActiveSection={setActiveSection}
                                replaceMessages={replaceMessages}
                                removeAllMessages={removeAllMessages}
                            />
                        </FullWidthContainerBody>
                    </WithRoutePermission>
                )}
            />
        </Switch>
    )
}
